export default {
  errors: null,
  shippings: [],
  loading: false,
  count: 0,
  totalCount: 0
};
